import { useState, useEffect } from 'react';
import { Card, Button, Row, Col, Spinner } from 'react-bootstrap';
import { STATIC_URL } from '../../config';

const FIREBASE_URL = 'https://appdistribution.firebase.dev/i/2ef7c5dc82e15bcc';
const VERSION_API_URL = `${STATIC_URL}/api/app/version`;

const DownloadPage = () => {
  const [versionName, setVersionName] = useState(null);

  useEffect(() => {
    fetch(VERSION_API_URL)
      .then((res) => res.json())
      .then((data) => setVersionName(data.latestVersionName))
      .catch(() => {});
  }, []);

  const v = versionName ?? '...';
  const apkUrl = versionName
    ? `https://assets.nogi46.me/release/SakaMessage-global-release-${versionName}.apk`
    : '#';
  const apkCnUrl = versionName
    ? `https://assets.nogi46.me/release-china/SakaMessage-china-release-${versionName}.apk`
    : '#';

  const options = [
    {
      icon: 'bi-google-play',
      iconColor: '#4285f4',
      title: 'Firebase App Distribution',
      description: '透過 Firebase 下載，需要 Google 帳號登入，可自動接收更新通知。',
      buttonLabel: '前往下載',
      buttonVariant: 'primary',
      url: FIREBASE_URL,
    },
    {
      icon: 'bi-android2',
      iconColor: '#3ddc84',
      title: '直接下載 APK',
      description: '直接下載安裝檔（APK）',
      buttonLabel: `下載 APK (v${v})`,
      buttonVariant: 'success',
      url: apkUrl,
    },
    {
      icon: 'bi-cloud-download',
      iconColor: '#ff6b35',
      title: '中國地區 APK',
      description: '針對中國大陸網路環境優化通知版本',
      buttonLabel: `下載 APK（中國地區）(v${v})`,
      buttonVariant: 'warning',
      url: apkCnUrl,
    },
  ];

  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="py-5 px-3 w-100" style={{ maxWidth: '960px' }}>
        <div className="text-center mb-5">
          <i className="bi bi-android2" style={{ fontSize: '3rem', color: '#3ddc84' }}></i>
          <h2 className="mt-3 mb-2">下載 Android App</h2>
          <p className="text-muted">選擇適合你的下載方式</p>
        </div>
        {versionName === null && (
          <div className="text-center mb-4">
            <Spinner animation="border" size="sm" className="me-2" />
            <span className="text-muted small">載入版本資訊中…</span>
          </div>
        )}
        <Row className="g-4 justify-content-center">
          {options.map((opt) => (
            <Col xs={12} md={4} key={opt.title}>
              <Card className="h-100 border-0 shadow-sm text-center w-100" style={{ borderRadius: '12px' }}>
                <Card.Body className="p-4 d-flex flex-column align-items-center">
                  <i className={`bi ${opt.icon} mb-3`} style={{ fontSize: '2.5rem', color: opt.iconColor }}></i>
                  <h5 className="mb-2">{opt.title}</h5>
                  <p className="text-muted small mb-4 flex-grow-1">{opt.description}</p>
                  <Button variant={opt.buttonVariant} href={opt.url} target="_blank" rel="noopener noreferrer">
                    {opt.buttonLabel}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default DownloadPage;
